// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3pFwQ","content":"styles_content__3Jtyc"};